<template>
  <div class="selectTeacher">
    <el-page-header @back="goback" content="咨询完成" > </el-page-header>
    <el-card class="box-card">
      <AppointInfo :appoint="appoint"></AppointInfo>
    </el-card>
    <p class="text-center mt10" :class="getStatusClass(appoint.label)">{{parseAppointStatus(appoint.status)}}</p>
    <el-card v-if="appoint.feedback" class="box-card" style="text-align:center;">
      <p>这次会谈，我认为是“{{arrFeedback1Info.join(',')}}”；</p>
      <p>会谈结束后，我的情绪是“{{arrFeedback2Info.join(',')}}”。</p>
      <p @click="diagFeedbackView=true">全部评价<i class="el-icon-arrow-down el-icon--right"></i></p>
    </el-card>
    <div  style="text-align:center;margin-top:12px;">
      <el-button type="primary" round style="width: 100%;" @click="diagFeedbackAdd=true" >反馈打分</el-button>
    </div>
    <DialogFeedback v-if="diagFeedbackAdd" @cancel-addFeedback="diagFeedbackAdd=false" @save-addFeedback="saveFeedback"></DialogFeedback>
    <el-dialog title="" :visible.sync="diagFeedbackView" width="100%" :show-close="true" @close="diagFeedbackView=false">
      <div class="feedback" v-if="appoint.feedback">
        <div class="subtitle colName">这次会谈，我认为是：（1-7打分，7分非常符合） </div>
        <el-row :gutter="20" v-for="item,index in arrFeedback1" :key="'1-'+index" >
          <el-col :span="6"><div class="colValue">{{arrFeedback1LowTitle[index]}}</div></el-col>
          <el-col :span="12"><el-progress :percentage="arrFeedback1[index]*100/7" :color="customColors" :format="formatProgress"></el-progress></el-col>
          <el-col :span="6"><div class="colValue">{{arrFeedback1HighTitle[index]}}</div></el-col>
        </el-row>
        <div class="subtitle colName">这次会谈结束后，我的情绪是：（1-7打分，7分非常符合） </div>
        <el-row :gutter="20" v-for="item,index in arrFeedback1" :key="'2-'+index" >
          <el-col :span="6"><div class="colValue">{{arrFeedback2LowTitle[index]}}</div></el-col>
          <el-col :span="12"><el-progress :percentage="arrFeedback2[index]*100/7" :color="customColors" :format="formatProgress"></el-progress></el-col>
          <el-col :span="6"><div class="colValue">{{arrFeedback2HighTitle[index]}}</div></el-col>
        </el-row>
        <div class="subtitle colName">我对约谈的咨询师，还有话想表达：</div>
        <div class="colValue">{{feedback3}}</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import HttpRequest from "@/utils/request";
import { parseAppointStatus,getStatusClass } from "@/utils/status.js";
import AppointInfo from '@/components/appointInfo'
import DialogFeedback from '../components/dialogFeedback';
export default {
  components: {
    AppointInfo,
    DialogFeedback,
  },
  data() {
    return {
      appoint: {},
      scheduleId: null,
      pathfrom: null,
      diagFeedbackAdd: false,
      diagFeedbackView: false,
      customColors: [
          {color: '#e9515e', percentage: 20},
          {color: '#ffc104', percentage: 40},
          {color: '#01b09a', percentage: 60}
        ],
      arrFeedback1LowTitle: ['无价值','肤浅','紧张','空虚','虚弱'],
      arrFeedback1HighTitle: ['有价值','有深度','放松','详尽','有力量'],
      arrFeedback2LowTitle: ['沮丧','躁动','无所适从','害怕','敌意'],
      arrFeedback2HighTitle: ['愉快','平静','内心充实','自信','友善'],
      arrFeedback1:[0,0,0,0,0],
      arrFeedback2:[0,0,0,0,0],
      arrFeedback1Info:[],
      arrFeedback2Info:[],
      feedback3:'',
      //
      parseAppointStatus,
      getStatusClass,
    };
  },
  computed: {
    ...mapState({
      student: (state) => state.user.student,
    }),
  },
  created() {
    if (this.$route.query.scheduleId) {
      this.scheduleId = this.$route.query.scheduleId;
      this.getSchedule();
    }
    else{
      this.$alert('请求url缺乏必须的参数',  {confirmButtonText: '确定',showClose: false,});
    }
    this.pathfrom = this.$route.query.pathfrom;
  },
  mounted() {
    document.title = '预约详情';
  },
  methods: {
    goback() {
      // this.$router.back();
      this.$router.push("appointView");
    },
    getSchedule(){
      let url = "/constub/getSchedule";
      let data = { token: this.student.token, scheduleId: this.scheduleId };
      HttpRequest.requestFormPost(url, data).then(res => {
        if (res && res.result.success) {
          this.appoint = res.data;
          //
          this.parseFeedback();
          console.info('this.appoint.status：'+this.appoint.status)
          if(this.appoint.status != 80 && this.appoint.status != 82 && this.appoint.status != 88 && this.appoint.status != 90 ){  //判断状态是否正确
            this.$message({message: '预约状态已变更，跳转回原路径',type: "error",});
            this.$router.push(this.pathfrom?this.pathfrom:'home');
          }
        } else {
          this.$alert(res.result.message,  {confirmButtonText: '确定',showClose: false,});
        }
      });
    },
    //提交反馈
    saveFeedback(submitdata){
      let url = "/constub/feedbackAppoint";
      let data = { token: this.student.token,scheduleId: this.scheduleId,feedback:submitdata};
      HttpRequest.requestFormPost(url, data).then((res) => {
        if (res && res.result.success) {
          this.$message({message: '提交反馈成功',type: "success",});
          this.diagFeedbackAdd=false;
          //刷新
          this.getSchedule();
        } else {
          this.$alert(res.result.message,  {confirmButtonText: '确定',showClose: false,});
        }
      });
    },
    formatProgress(percentage){
      return Math.round(percentage*7/100);
    },
    parseFeedback(){
      //来访反馈字段解析
      if(this.appoint.feedback){
        let arrFeedback,arrFeedback1,arrFeedback2,arrFeedback3
        arrFeedback=this.appoint.feedback.split('}');
        if(arrFeedback.length>=1){
          arrFeedback1=arrFeedback[0].split('$')
          this.arrFeedback1=arrFeedback1[1].split(',').map(num=>{
            return parseInt(num.substring(num.indexOf('>')+1,num.length));
          })
          for(let i=0;i<arrFeedback1[1].split(',').length;i++){
            let num = arrFeedback1[1].split(',')[i];
            let score = parseInt(num.substring(num.indexOf('>')+1,num.length));
            this.arrFeedback1Info[i]=score>=4?this.arrFeedback1HighTitle[i]:this.arrFeedback1LowTitle[i];
          }
        }
        if(arrFeedback.length>=2){
          arrFeedback2=arrFeedback[1].split('$')
          this.arrFeedback2=arrFeedback2[1].split(',').map(num=>{
            return parseInt(num.substring(num.indexOf('>')+1,num.length));
          })
          for(let i=0;i<arrFeedback2[1].split(',').length;i++){
            let num = arrFeedback2[1].split(',')[i];
            let score = parseInt(num.substring(num.indexOf('>')+1,num.length));
            this.arrFeedback2Info[i]=score>=4?this.arrFeedback2HighTitle[i]:this.arrFeedback2LowTitle[i];
          }
        }
        if(arrFeedback.length>=3){
          arrFeedback3=arrFeedback[2].split('$')
          this.feedback3=arrFeedback3[1]
        }
      }
    },
  },
};
</script>
<style scoped>
>>> .el-dialog {
  position: absolute;
  bottom: 0;
  margin: 0;
}

p {
  line-height: 24px;
}
.borderrd {
  border-radius: 10px;
  border: 1px solid #ccc;
  padding: 10px;
  margin-bottom: 10px;
}

.feedback {
  padding-left:12px;
}

.feedback .subtitle {
  margin-top:12px;
}

.colName {
  color: #777777;
}

.colValue {
  color: #101010;
}

</style>
